/**
 * useCoPilotConfig - Load co-pilot configuration from admin settings
 * 
 * Fetches settings from unified API:
 * - display_name: Header title
 * - welcome_message: Initial greeting
 * - summary_on_close: Auto-summarize on close
 * - quick_actions: Array of quick action buttons
 * - editable_fields: Fields AI can suggest updates for
 *
 * No fallbacks. If the config endpoint fails, config stays null
 * and the component must show an error state.
 */
import { useState, useEffect, useCallback } from 'react';
import { unifiedCopilotApi } from '../../../services/api';

export const useCoPilotConfig = (contextType) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadConfig = useCallback(async () => {
    if (!contextType) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const res = await unifiedCopilotApi.getConfig(contextType);
      setConfig(res.data);
    } catch (err) {
      console.error(`[useCoPilotConfig] Failed to load config for "${contextType}":`, err?.response?.data?.detail || err.message);
      setError(err?.response?.data?.detail || `Failed to load copilot config for "${contextType}"`);
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, [contextType]);

  useEffect(() => {
    loadConfig();
  }, [loadConfig]);

  return { config, loading, error, reload: loadConfig };
};

export default useCoPilotConfig;
